import "./style.css";
import Desktop from "./desktop";

const desktop = new Desktop();
desktop.activateEvents();
